
import React from 'react';
import { t } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
    ControlPanelsContainerProps,
} from '@superset-ui/chart-controls';
import { legendSection } from '../../../controls';
import { commonControlsConfig } from '../utils';
import { DEFAULT_FORM_DATA } from './types';

// basic

const { showLabels } = DEFAULT_FORM_DATA;

const barLegendSection = [...legendSection];
barLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
     sections.legacyRegularTime,
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        [
          {
            name: 'enable_drill_down',
            config: {
              type: 'CheckboxControl',
              label: t('Enable DrillDown'),
              renderTrigger: false,
              default: DEFAULT_FORM_DATA.enableDrillDown,
              description: t('To enable selection of multiple columns for DrillDown Query.'),
            },
          },
        ],
        [
          {
            name: 'groupby',
            config: {
              ...sharedControls.groupby,
              multi: false,
              label: t('Category Column'),
              description: t('Column values to use as categories.'),
            },
          },
        ],
        [
          {
            name: 'drill_down_groupby',
            config: {
              ...sharedControls.groupby,
              multi: true,
              label: t('Drilldown Columns'),
              description: t('Column values to use as categories for each level.'),
              visibility: ({ controls }: ControlPanelsContainerProps) =>
                Boolean(controls?.enable_drill_down?.value),
            },
          },
        ],

        ['metrics'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
              name: 'row_limit',
              config: {
              ...sharedControls.row_limit,
              default: 10,
              },
          },
        ]
       ],
     },
     {
       label: t('Chart Options'),
       expanded: true,
       controlSetRows: [
         ['color_scheme'],
         ...barLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
        //  [
        //    {
        //      name: 'label_type',
        //      config: {
        //        type: 'SelectControl',
        //        label: t('Label Type'),
        //        default: labelType,
        //        renderTrigger: true,
        //        choices: [
        //          [EchartsFunnelLabelTypeType.Key, 'Category Name'],
        //          [EchartsFunnelLabelTypeType.Value, 'Value'],
        //          [EchartsFunnelLabelTypeType.Percent, 'Percentage'],
        //          [EchartsFunnelLabelTypeType.KeyValue, 'Category and Value'],
        //          [
        //            EchartsFunnelLabelTypeType.KeyPercent,
        //            'Category and Percentage',
        //          ],
        //          [
        //            EchartsFunnelLabelTypeType.KeyValuePercent,
        //            'Category, Value and Percentage',
        //          ],
        //        ],
        //        description: t('What should be shown on the label?'),
        //      },
        //    },
        //  ],
        //  [
        //    {
        //      name: 'number_format',
        //      config: {
        //        type: 'SelectControl',
        //        freeForm: true,
        //        label: t('Number format'),
        //        renderTrigger: true,
        //        default: numberFormat,
        //        choices: D3_FORMAT_OPTIONS,
        //        description: `${t(
        //          'D3 format syntax: https://github.com/d3/d3-format',
        //        )} ${t('Only applies when "Label Type" is set to show values.')}`,
        //      },
        //    },
        //  ],
         [
           {
             name: 'show_labels',
             config: {
               type: 'CheckboxControl',
               label: t('Show Labels'),
               renderTrigger: true,
               default: showLabels,
               description: t('Whether to display the labels.'),
             },
           },
         ],
         [
          {
            name: 'combineMetrics',
            config: {
              ...commonControlsConfig.combineMetrics,
              default: DEFAULT_FORM_DATA.combineMetrics
            }
          }
         ]
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => ({
     ...formData,
     metric: formData.standardizedFormData.standardizedState.metrics[0],
     groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 